import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/icons/vector.png'


const _hoisted_1 = { class: "todays-appointments-card trezo-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "appointments-list position-relative scrollbar" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "info d-flex align-items-center" }
const _hoisted_8 = { class: "d-block text-black fw-semibold" }
const _hoisted_9 = {
  key: 0,
  type: "button",
  class: "notification-btn bg-primary text-white p-0 border-0 rounded-circle"
}
const _hoisted_10 = {
  key: 1,
  class: "trezo-badge bg-white"
}
const _hoisted_11 = { class: "user d-flex align-items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "d-block text-black fw-semibold" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "popup-dialog" }
const _hoisted_16 = { class: "trezo-card card w-100 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_17 = { class: "trezo-card-header d-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "trezo-card-subtitle" }
const _hoisted_19 = { class: "trezo-card-content" }
const _hoisted_20 = { class: "p-0 m-0 list-unstyled" }
const _hoisted_21 = { class: "fw-medium text-black" }
const _hoisted_22 = { class: "time text-black" }
const _hoisted_23 = { class: "fw-medium text-black" }
const _hoisted_24 = { class: "fw-medium text-black" }
const _hoisted_25 = { class: "patient-name d-flex align-items-center" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "trezo-badge finished fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-header d-flex align-items-center justify-content-between" }, [
        _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0" }, "Today's Appointments")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (appointment, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "appointment-item position-relative z-1 border-radius"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: appointment.icon,
                  alt: appointment.status
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(appointment.time), 1),
                    (appointment.status === 'upcoming')
                      ? (_openBlock(), _createElementBlock("button", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("i", { class: "ri-notification-2-line" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (appointment.status === 'upcoming')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Upcoming "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(appointment.description), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: appointment.user.image,
                      class: "rounded-circle",
                      alt: "user-image"
                    }, null, 8, _hoisted_12),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(appointment.user.name), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: ($event: any) => (_ctx.toggleClass(appointment))
                }, " View Details ", 8, _hoisted_14)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "shape position-absolute start-0 end-0 text-center z-n1 top-0 mx-auto" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "vector"
                })
              ], -1))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["add-new-popup", { active: _ctx.classApplied }])
    }, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "trezo-card-title" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Schedule Details")
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleClass(null))),
                class: "p-0 border-0 lh-1 bg-transparent transition"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("ul", _hoisted_20, [
              _createElementVNode("li", _hoisted_21, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "d-block fw-normal text-body" }, " Date ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedAppointment?.date), 1)
              ]),
              _createElementVNode("li", _hoisted_22, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "d-block fw-normal text-body" }, " Time ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedAppointment?.time), 1)
              ]),
              _createElementVNode("li", _hoisted_23, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "d-block fw-normal text-body" }, " Schedule Description ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedAppointment?.description), 1)
              ]),
              _createElementVNode("li", _hoisted_24, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "d-block fw-normal text-body" }, " Patient Name ", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("img", {
                    src: _ctx.selectedAppointment?.user.image,
                    alt: "patient-image",
                    class: "rounded-circle"
                  }, null, 8, _hoisted_26),
                  _createElementVNode("span", null, _toDisplayString(_ctx.selectedAppointment?.user.name), 1)
                ])
              ]),
              _createElementVNode("li", null, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "d-block fw-normal" }, " Schedule Status ", -1)),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.selectedAppointment?.status), 1)
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}